import { Pin, Trash2, MoreVertical } from "lucide-react";
import { Button } from "@lyder-talk/ui";
import type { HistorySession } from "@/hooks/use-practice-sessions";
import { SidebarRow } from "@/components/layout/SidebarShell";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface SessionItemWithActionsProps {
  session: HistorySession;
  isPinned: boolean;
  isMobile: boolean;
  active?: boolean;
  onTogglePin: (sessionId: string) => void;
  onDelete: (sessionId: string) => void;
  onClick: () => void;
}

export const SessionItemWithActions = ({
  session,
  isPinned,
  isMobile,
  active = false,
  onTogglePin,
  onDelete,
  onClick,
}: SessionItemWithActionsProps) => {
  return (
    <SidebarRow
      active={active}
      onClick={onClick}
      actions={
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="h-6 w-6 hover:bg-primary/15 data-[state=open]:bg-primary/15"
              title="More options"
              onClick={(e) => e.stopPropagation()}
            >
              <MoreVertical
                className={`text-muted-foreground hover:text-primary ${isMobile ? "w-4 h-4" : "w-3.5 h-3.5"}`}
              />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            side={isMobile ? "bottom" : "right"}
            className={isMobile ? "min-w-[160px]" : "min-w-[140px]"}
          >
            <DropdownMenuItem
              onClick={(e) => {
                e.stopPropagation();
                onTogglePin(session.id);
              }}
              className={`cursor-pointer ${isMobile ? "min-h-[44px] text-base" : ""}`}
            >
              <Pin className={`mr-2 ${isMobile ? "w-4 h-4" : "w-3.5 h-3.5"}`} />
              {isPinned ? "Unpin" : "Pin"}
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={(e) => {
                e.stopPropagation();
                onDelete(session.id);
              }}
              className={`text-destructive focus:text-destructive cursor-pointer ${isMobile ? "min-h-[44px] text-base" : ""}`}
            >
              <Trash2 className={`mr-2 ${isMobile ? "w-4 h-4" : "w-3.5 h-3.5"}`} />
              Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      }
    >
      <span className="block truncate text-sm">{session.topic}</span>
    </SidebarRow>
  );
};
